/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgMsgSuccess = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 40 40"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <rect width={40} height={40} fill="#30B566" rx={20} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M31.328 15.5 18.914 27.914a2 2 0 0 1-2.828 0L8.672 20.5l2.828-2.828 6 6 11-11 2.828 2.828Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgMsgSuccess)
export default Memo
